import React from "react"

import moment from "moment/moment";

import { withRouter } from "react-router-dom";

import Edit from "./cells/Edit";

import BaseTable from "./BaseTable"
import Mappings from "../modal/Mappings";


class BulkUploadMappingsTable extends React.Component {

  constructor(props) {
    super(props)

    this.state = {

    }

    this.table = React.createRef()
  }


  _getColumns(){
    let columns = [
      {
        Header: "Date Created",
        accessor: mapping => moment(mapping.created_at).format('DD MMM YYYY HH:mm'),
        id: "created_at",
        type: "date",
        format: "%d %b %Y"
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Form",
        id: "form",
        accessor: mapping => mapping.form.name,
      },
      {
        Header: "",
        id: '',
        sortable: false,
        exportable: false,
        Cell: rowInfo => {
          let mapping = rowInfo.original
          return (
            <div className={"text-end my-auto"}>
              <Edit
                onEditClicked={() => this.setState({
                  showMappingModal: true,
                  selectedMapping: mapping,
                })}
              />
            </div>
          )
        }
      }
    ]

    return columns
  }


  render() {
    let {
      selectedMapping,
      showMappingModal,
    } = this.state

    const columns = this._getColumns()

    return (
      <>
        <BaseTable
          ref={this.table}
          endpoint={window.Api.BulkUploadMappings}
          noDataMessage={"No Bulk Upload Mappings found"}
          title={this.props.title}
          subtitle={this.props.subtitle}
          showFilter={false}
          columns={columns}
          defaultSorted={[
            {
              id: "created_at",
              desc: true
            }
          ]}
        />
        { showMappingModal &&
          <Mappings
            show={showMappingModal}
            parser={selectedMapping.parser || "platform"}
            mapping={selectedMapping}
            onHide={() => {
              this.setState({ showMappingModal: false });
            }}
            onCreated={() => {
              this.setState({ showMappingModal: false, selectedMapping: null });
            }}
          />
        }
      </>
    )

  }

}

export default withRouter(BulkUploadMappingsTable);
